export const dateFormat1 = 'DD/MMM/YYYY'

export const dateFormat2  = "YYYY-MM-DD"

export const dateFormat3 = 'DD/MMM/YYYY'

export const apiErrorText = ['error','failed']